import { get, post, put, patch, del } from '../util/http';
import { ENDPOINTS } from '../util/endpoints';

export const userService = {
  list:          (params)       => get(ENDPOINTS.users.list, { params }),
  getById:       (id)           => get(ENDPOINTS.users.byId(id)),
  getMe:         ()             => get(ENDPOINTS.users.me),
  create:        (data)         => post(ENDPOINTS.users.list, data),
  update:        (id, data)     => put(ENDPOINTS.users.byId(id), data),
  updateMe:      (data)         => put(ENDPOINTS.users.me, data),
  remove:        (id)           => del(ENDPOINTS.users.byId(id)),
  activate:      (id)           => patch(ENDPOINTS.users.activate(id)),
  deactivate:    (id)           => patch(ENDPOINTS.users.deactivate(id)),
  resetPassword: (id)           => patch(ENDPOINTS.users.resetPassword(id)),
  changePassword:(data)         => put(ENDPOINTS.users.password, data),
};
